export const SET_OBJECT = 'SET_OBJECT';
export const CLEAR_OBJECT = 'CLEAR_OBJECT';
export const SET_OBJECT_PAGE = 'SET_OBJECT_PAGE';
export const SET_OBJECT_ID = 'SET_OBJECT_ID';
export const UPDATE_ROOM_LIST = 'UPDATE_ROOM_LIST';
export const SET_HISTORY_LIST = 'SET_HISTORY_LIST';
export const SET_HISTORY_NAV_PARAMS = 'SET_HISTORY_NAV_PARAMS';
export const SET_CHANNEL_MANAGER_LIST = 'SET_CHANNEL_MANAGER_LIST';
export const SET_PRICES_TYPES_LIST = 'SET_PRICES_TYPES_LIST';
export const UPDATE_STEP_BY_STEP = 'UPDATE_STEP_BY_STEP';
